import React from 'react'

const Definition = () => {
  return (
    <div className='section definition'>
      <div className='heading'>water</div>
      <div className='sub-heading'>(noun)</div>
      <p>
        a colourless, transparent, odourless liquid that forms the seas, lakes,
        rivers, and rain and is the basis of the fluids of living organisms, in
        short, "the source of life".
      </p>
    </div>
  )
}

export default Definition
